<h4>{{'feature.artist.artist_management' | translate}}</h4>
<button (click)="openCreateDialog($event)" class="btn btn-primary m-2 rounded-pill">{{ 'common.button.add'| translate }}</button>
<table class="table table-striped">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col" id="name">{{ 'feature.artist.artist_name' | translate }}</th>
      <th scope="col" id="birthDate">{{ 'BirthDate' | translate }}</th>
      <th scope="col">{{ 'Avatar' | translate }}</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr
      [routerLink]="['/','admin','artist-management','detail']"
      [queryParams]="{id: artist.id}"
      *ngFor="let artist of artistPage.content; index as i"
    >
      <td>{{ i + 1 }}</td>
      <td><a [routerLink]="['/','admin','artist-management','detail']" [queryParams]="{id: artist.id}">{{ artist.name }}</a></td>
      <td>{{ artist.birthDate | date: 'dd/MM/yyyy' : '' : translate.currentLang }}</td>
      <td><img [src]="artist.avatarUrl | mediaUrl" class="avatar" alt="" /></td>
      <td>
        <button (click)="openEditDialog(artist, $event)" class="btn btn-secondary m-2 btn-sm rounded-circle">
          <i class="bi bi-pencil-square"></i>
        </button>
        <button (click)="openDeleteDialog(artist, $event)" class="btn btn-danger btn-sm m-2 rounded-circle">
          <i class="bi bi-trash"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>
<ngb-pagination
  [collectionSize]="artistPage.totalElements"
  [page]="artistPage.pageable?.pageNumber + 1"
  [pageSize]="artistPage.pageable?.pageSize"
  (pageChange)="getArtistList($event - 1)"
></ngb-pagination>
